import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: start;
`;

export const Article = styled.div`
  max-width: 110rem;
  width: 100%;
`;

export const StyledHeading = styled.h2`
  @media (max-width: 48rem) {
    font-size: 2rem;
  }
`;
